// extracted by css-extract-rspack-plugin
export default {"notification-box":"notification-box-GQULn9","notificationBox":"notification-box-GQULn9","container":"container-FNB3EP","cta":"cta-DPJZPT"};